var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.article
        ? [
            _c(
              "transition",
              { attrs: { name: "slide-l", mode: "out-in", appear: "" } },
              [
                _c("div", { staticClass: "panel wraper panel-gray" }, [
                  _c("div", { staticClass: "panel-header" }, [
                    _c(
                      "div",
                      { staticClass: "panel-title" },
                      [_c("article-path", { attrs: { id: _vm.fullId } })],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "panel-body" },
                    [
                      _vm.currentType === "a"
                        ? _c("p", { staticClass: "in-top" }, [
                            _c(
                              "small",
                              { staticClass: "view-label" },
                              [
                                _c("q-icon", {
                                  attrs: { name: "fas fa-user-edit" }
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.authorName) +
                                    " " +
                                    _vm._s(
                                      _vm._f("formatTime")(_vm.versionTime)
                                    ) +
                                    "\n              "
                                )
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-runtime-template", {
                        attrs: { template: _vm.template }
                      }),
                      _vm._v(" "),
                      _vm.article.tags
                        ? _c(
                            "p",
                            { staticClass: "group" },
                            _vm._l(_vm.article.tags, function(tag, ind) {
                              return _c(
                                "q-chip",
                                {
                                  key: ind,
                                  attrs: { small: "", color: "primary" }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(tag) +
                                      "\n              "
                                  )
                                ]
                              )
                            })
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("tree-wiki", { attrs: { base: _vm.fullId } })
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.notDemo && _vm.article._id
              ? _c("pop-btn", {
                  staticClass: "mobile-hide",
                  attrs: { btns: _vm.btns }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.notDemo && _vm.article._id
              ? _c("pop-hold", {
                  staticClass: "mobile-only",
                  attrs: { btns: _vm.btns }
                })
              : _vm._e()
          ]
        : [
            _c(
              "div",
              { staticClass: "row justify-center" },
              [
                _c("q-spinner-dots", { attrs: { size: 100, color: "primary" } })
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22855774", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22855774","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wiki-view.vue
// module id = null
// module chunks = 